import { Modal, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loading } from "../../components/Loading";
import { TitleBar } from "../../components/TitleBar";
import { createGroup } from "../../models/groups";
import { RootState, getGroup, useAppDispatch, useAppSelector } from "../../redux";
import { MyBoxModal } from "../../styled-components";
import { Materials } from "../materials";
import { MyForm } from "./components";

export const GroupsItems = () => {
    const { id } = useParams();
    const dispatch = useAppDispatch();
    const { isLoading, group } = useAppSelector((state: RootState) => state.groups);

    useEffect(() => {
        if (id)
            dispatch(getGroup(id));
    }, [dispatch, id])

    const [dialogOpen, setDialogOpen] = useState(false);
    const openDialog = () => setDialogOpen(!dialogOpen);
    const [editing, setEditing] = useState(false);
    const [groupToEdit, setGroupToEdit] = useState(createGroup({}));
    const onEdit = () => {
        setGroupToEdit(createGroup(group));
        setEditing(true);
        openDialog();
    }

    return (
        <div>
            <Loading isLoading={isLoading} />
            <TitleBar onEdit={onEdit} title={`Group: ${group.name}`} urlToBack='/groups/' />
            <br />
            <Typography variant="h6" component="h2">Materials</Typography>
            <br />
            <Materials isToAddMaterials={true} entity="groups" idParent={id} />
            <Modal open={dialogOpen} onClose={openDialog}>
                <MyBoxModal>
                    <MyForm onCancel={openDialog} group={groupToEdit} editing={editing} />
                </MyBoxModal>
            </Modal>
        </div>
    )
}
